class ColoredCardBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.number = block.querySelector('.colored-card__number');
    this.root = attributes ? this.block.parentNode.parentNode.parentNode.parentNode : this.block;
    this.number.innerText = [...this.root.parentNode.children].indexOf(this.root) + 1;
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.colored-card').forEach((block) => {
  new ColoredCardBlock(block);
});

// Initialize password protected pages
window.addEventListener('init', () => {
  document.querySelectorAll('.colored-card').forEach((block) => {
    new ColoredCardBlock(block);
  });
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=colored-card', ($block, attributes) => {
    new ColoredCardBlock($block.find('.colored-card').get(0), attributes);
  });
}